import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar/Sidebar";
import useSidebarToggle from "../../hooks/useSidebarToggle";
import Topbar from "./Topbar";
import { Users, Activity, Settings as SettingsIcon, Banknote, Search, History, Zap } from "lucide-react";
import type { MenuItem, SidebarTheme } from "../../types/sidebar";
import { useEffect } from "react";
import { useAuth } from "../../hooks/useAuth";

export function AdminLayout() {
    const { isOpen, toggle } = useSidebarToggle();
    const navigate = useNavigate();
    const { user } = useAuth();

    useEffect(() => {
        if (!user?.isAdmin) {
            navigate("/dashboard");
        }
    }, [user, navigate]);

    // ADMIN MENU
    const adminMenu: MenuItem[] = [
        { name: "Overview", path: "/admin", icon: <Activity className="w-5 h-5" />, end: true },
        { name: "New Scrape", path: "/admin/new", icon: <Search className="w-5 h-5" /> },
        { name: "Scrape History", path: "/admin/history", icon: <History className="w-5 h-5" /> },
        { name: "Users", path: "/admin/users", icon: <Users className="w-5 h-5" /> },
        { name: "Platform Pricing", path: "/admin/pricing", icon: <Banknote className="w-5 h-5" /> },
        { name: "Sessions", path: "/admin/sessions", icon: <Zap className="w-5 h-5" /> },
        { name: "Platform", path: "/admin/settings", icon: <SettingsIcon className="w-5 h-5" /> },
    ];

    // Dark theme for Admin
    const adminTheme: SidebarTheme = {
        bgColor: "bg-[#111111]",
        borderColor: "border-white/10",
        hoverBg: "hover:bg-white/5",
        activeColor: "text-purple-400",
        activeBg: "bg-purple-500/10",
    };

    return (
        <div className="flex h-screen overflow-hidden bg-black text-white isolate">
            <Sidebar
                isOpen={isOpen}
                toggleSidebar={toggle}
                mainMenu={adminMenu}
                theme={adminTheme}
                expandedWidth="w-68"
                collapsedWidth="w-24"
            />

            <div className="flex-1 flex flex-col min-w-0 w-full overflow-hidden bg-[#0a0a0a]">
                <Topbar onMenuClick={toggle} />

                <div className="flex-1 overflow-x-hidden overflow-y-auto w-full custom-scrollbar">
                    <div className="p-4 md:p-8">
                      <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminLayout;
